<template>
  <div id="warn" class="h100" />
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "DeviceWarn",
  props: {
    propData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusChart: null
    };
  },
  watch: {
    propData: {
      handler() {
        this.initStatus();
      }
    }
  },
  mounted() {
    this.initStatus();
    window.onresize = () => (() => {
      this.statusChart.resize();
    })();
  },
  methods: {
    initStatus() {
      this.$nextTick(() => {
        this.statusChart = echarts.init(document.getElementById("warn"));
        this.statusChart.setOption({
          tooltip: {
            trigger: "item",
            padding: 0,
            borderWidth: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            formatter: params => `<div class="status-tooltip-content">
                 <div class="status-tooltip-title">
                   <div class="status-tooltip-tip" style="background: ${params.color}"></div>
                   <span>${params.name}</span>
                 </div>
                 <div class="status-tooltip-num">
                   <span style="margin-right: 10px;">${params.value}</span>
                   <span>${params.percent}%</span>
                 </div>
              </div>`
          },
          color: ["#E60000", "#FF6922", "#FF9900"],
          series: [
            {
              name: "",
              type: "pie",
              radius: ["46%", "65%"],
              // avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  borderWidth: 3,
                  borderColor: "#fff"
                }
              },
              label: {
                normal: {
                  show: true,
                  color: "rgba(80, 83, 99, .75)",
                  position: "outside",
                  formatter: "{b}\n{d}%"
                }
              },
              data: this.propData
            }
          ]
        });
      });
    }
  }
};
</script>

<style>
.status-tooltip-content {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  padding: 8px 18px;
  min-width: 100px;
}
.status-tooltip-title {
  position: relative;
  margin-bottom: 2px;
}
.status-tooltip-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 6px;
  left: -10px;
}
</style>
